import React, { useEffect, useState, useRef } from "react";
//i18n
import { withNamespaces } from "react-i18next";

import {
  Row,
  Col,
  Card,
  CardBody,
  FormGroup,
  Button,
  Label,
  Spinner
} from "reactstrap";

import { AvForm, AvField } from "availity-reactstrap-validation";
// Redux
import { connect } from "react-redux";
import {  withRouter } from "react-router-dom";


import moment from "moment";
import { postSubmitForm } from "../../../../helpers/forms_helper";

import Select from "react-select";
import makeAnimated from "react-select/animated";
import { formatUnitsForReport, GetUpdatedDelivered } from "../../../../helpers/units";
import showNotification from "../../../../helpers/show_notification";
import preloader from "../../../../helpers/preloader";
import EnterQuantityForManualInventory from "../../../../components/EnterQuantityForManualInventory";
import UpdateQuantityForManualInventory from "../../../../components/UpdateQuantityForManualInventory";
const animatedComponents = makeAnimated();

const AddOpeningComp = (props) => {
  useEffect(() => {
    loadAllItems();
    if (props.selectedItem) {
      setSelectedItem(props.selectedItem);
      setSelectUnitModal(true)
    }
  }, []);
  const [currentDate] = useState(() => {
    var d1 = new Date();
    var d = moment(d1).add(1, "days").toDate();
    var month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("-");
  });
  const refContainer = useRef(null);
  const refSelectItem = useRef(null);
  let store_id = localStorage.getItem("store_id")
  let role = localStorage.getItem("role")

  const [isDisabled, setIsDisabled] = useState(false)
  const handleValidSubmit = async (e, v) => {
    try {
      if(!selectedItem.quantity){
        // console.log(1);
        showNotification("Please enter a valid quantity","Warning")
        return
      }
      // else if (selectedItem.quantity && selectedItem.quantity.every(({ value }) => (value == "0" || value == 0 || value === ""))) {
      //   // console.log(2);
      //   showNotification("Please enter a valid quantity for at least one unit","Warning");
      //   return;
      // }
      let data_to_send = {};
      // console.log(3);
      data_to_send.store_id = store_id;
      data_to_send.item_id = selectedItem.item_id;
      data_to_send.quantity = selectedItem.quantity.map(({unit,value})=>({unit,value}));
      data_to_send.expiry_date = v.expiry_date;
      data_to_send.cost_price = +v.cost_price;
      if(role==="Storekeeper"){
        data_to_send.inventory_type = "Kitchen"
      }
      // console.log(data_to_send);return
      setIsDisabled(true)
      let url = process.env.REACT_APP_BASEURL + "storesitemstransfer/manual_entry";
      const response = await postSubmitForm(url, data_to_send);
      if (response && response.status === 1) {
        setIsDisabled(false)
        showNotification(response.message, "Success");
        refSelectItem.current.select.clearValue();
        refContainer.current.reset();
        if (props.isRefreshData) {
          props.refreshData();
          props.handleClosePopup();
        }
      } else {
        setIsDisabled(false)
        showNotification(response.message, "Error");
      }
    } catch (error) {
      setIsDisabled(false)
      showNotification(error?.message, "Error");
    }
  };

  const [allItems, setAllItems] = useState([]);
  const [selectedItem, setSelectedItem] = useState();
  const loadAllItems = async () => {
   try {
    preloader(true)
    let store_type = localStorage.getItem("store_type");
    let store_id = localStorage.getItem("store_id");
    let endPoint = "";
    let payload = {}
    switch(store_type){
      case "Branch" :
        //  endPoint = "branchitems/getforbranch";
         endPoint = "stores/getinventory";
         payload.type="item";
         break;
      case "Sub Store":
        endPoint = "branchitems/get_sub_store_items";
        payload.sub_store_id=store_id;
        break;
      case "CENTRAL KITCHEN STORE":
        // endPoint = "branchitems/getforbranch";
          endPoint = "stores/getinventory";
         payload.type="item";
        break;
      case "CENTRAL STORE":
        endPoint = "branchitems/getforbranch";
        break;
      case "Main Store":
        endPoint = "mainstoreitems/main_store_inventory";
        payload.store_id=store_id;
        break;
    }
    // console.log(endPoint,"Ep");    
    let url = process.env.REACT_APP_BASEURL + endPoint;
    let response = await postSubmitForm(url, payload);
    if (response.status === 1) {
      preloader(false)
     let filtered =  response.data.filter((d)=>d.is_active).map(obj=>({
        ...obj,
        label:obj.name,
        value:obj.item_id
      }))
      setAllItems(filtered);
    } else {
      preloader(false)
      showNotification(response.message, "Error");
    }
   } catch (error) {
    preloader(false)
      showNotification(error.message, "Error");
   }
  };
  const [selectUnitModal, setSelectUnitModal] = useState(false)
  function handleSelectItem (selected) {
    setSelectedItem(selected)
    setSelectUnitModal(!selectUnitModal)
  }

  const [editUnitModal, setEditUnitModal] = useState(false);


function handleToggle() {
    setSelectUnitModal(false);
    setEditUnitModal(false)
    // setSelectedItem({})
}
function handleAddQuantity(quantity) {
        const updatedProd = { ...selectedItem };
          let convertedQuantity = GetUpdatedDelivered(quantity,updatedProd.unit_levels)
          updatedProd.quantity=convertedQuantity
        setSelectedItem(updatedProd);
        setSelectUnitModal(false);
}
const handleUpdateQuantity = (quantity) => {
  const updatedProd = { ...selectedItem };
  let convertedQuantity = GetUpdatedDelivered(quantity,updatedProd.unit_levels)
  updatedProd.quantity=convertedQuantity
    setSelectedItem(updatedProd);
    setEditUnitModal(false);
};

  return (
    <React.Fragment>
      <Row>
        <Col lg={12}>
          <Card>
            <CardBody>
              <AvForm
                onValidSubmit={(e, v) => {
                  handleValidSubmit(e, v);
                }}
                ref={refContainer}
              >
                <Row>
                  <Col lg={6}>
                    <Label>{props.t("Item")}</Label>
                    <Select
                      ref={refSelectItem}
                      value={selectedItem}
                      onChange={(selected) => {
                        handleSelectItem(selected)
                      }}
                      options={allItems}
                      classNamePrefix="select2-selection"
                      components={animatedComponents}
                      required
                    />
                  </Col>
                  {selectedItem?.quantity?.length>0 && (
                    <Col lg={6}>
                    <Label>{props.t("Quantity")}</Label> <br />
                       {formatUnitsForReport(selectedItem?.quantity) }
                       <Button
                  className="btn btn-success waves-effect waves-light btn-sm ms-5"
                  onClick={() => {
                    setEditUnitModal(!editUnitModal);
                  }}
                >
                  <i class="mdi mdi-edit"></i>
                  {props.t("Edit")}
                </Button>
                  </Col>
                  )}
                  <Col lg={6} className="mt-1">
                    <Label>
                      {props.t("Cost Price")}
                      {selectedItem && " (per " + selectedItem.unit_for_po + ")"}
                    </Label>
                    <AvField
                      name="cost_price"
                      placeholder={props.t("Enter Cost Price")}
                      type="number"
                      value={Number(selectedItem?.latest_cost_price || 0)}
                      disabled
                      validate={{
                        pattern: {
                          value: /^(0|[1-9]\d*)(\.\d+)?$/,
                          errorMessage: props.t("Only numbers are allowed."),
                        },
                        required:{value:true,errorMessage: props.t("cost price is required."),
                        }
                      }}
                    />
                  </Col>
                  {/* <Col lg={6}>
                    <Label>
                      {props.t("Selling Price")}
                      {selectedItem && " (per " + selectedItem.unit + ")"}
                    </Label>
                    <AvField
                      name="selling_price"
                      placeholder={props.t("Enter Selling Price")}
                      type="text"
                      validate={{
                        pattern: {
                          value: /^(0|[1-9]\d*)(\.\d+)?$/,
                          errorMessage: props.t("Only numbers are allowed."),
                        },
                      }}
                    />
                  </Col> */}
                  <Col lg={6}>
                    <AvField
                      name="expiry_date"
                      label={props.t("Expiry Date") + " *"}
                      placeholder={props.t("Select Expiry Date")}
                      type="date"
                      min={currentDate}
                      required
                      errorMessage="Expiry date cannot be empty"
                    />
                  </Col>
                  {/* <Col lg={6}>
                    <AvField
                      name="remarks"
                      label={props.t("Remarks")}
                      placeholder={props.t("Enter Remarks")}
                      type="textarea"
                    />
                  </Col> */}
                  <Col lg={12}>
                    <hr />
                    <FormGroup className="mb-0 text-center">
                      <div>
                        <Button type="submit" style={{width:"100px"}} color="primary" className="mr-1" disabled={isDisabled}>
                        {isDisabled ? <Spinner size="sm" /> : props.t("Submit")} 
                        </Button>
                      </div>
                    </FormGroup>
                  </Col>
                </Row>
              </AvForm>
            </CardBody>
          </Card>

            {/* Add quanity modal  */}
      <EnterQuantityForManualInventory
        isOpen={selectUnitModal}
        toggle={handleToggle}
        onSubmit={handleAddQuantity}
        item={selectedItem}
      />

              {/* Edit quantity modal  */}
                <UpdateQuantityForManualInventory
                   isOpen={editUnitModal}
                   toggle={handleToggle}
                   onSubmit={handleUpdateQuantity}
                   item={selectedItem}
                  />
        </Col>
      </Row>
    </React.Fragment>
  );
};
const mapStatetoProps = (state) => {};
export default withRouter(
  connect(mapStatetoProps, {})(withNamespaces()(AddOpeningComp))
);
